.presence {
  margin-left: 8px;
  margin-right: 8px;
  flex-shrink: 0;
}

.menuButton {
  min-width: 32px;
  padding-right: 8px;
  flex-shrink: 0;
}

.breadcrumbs {
  /* Fill the free space: the breadcrumbs measure their own width to decide how many crumbs fit.
   * Shrunk to content, a collapsed path measures too narrow to ever expand. The favorite star
   * renders inside them, right after the last crumb. */
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

/* Small-screen title beside the path button: takes the free space, one line, truncated */
.title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: var(--tuna-typography-fontSize-md);
  font-weight: var(--tuna-typography-fontWeight-bold);
  color: var(--tuna-palette-text-primary);
}

.agents {
  display: inline-flex;
  flex-shrink: 0;
}

/* The pill renders nothing without agents: drop the empty slot and its hairline too */
.agents:empty,
.agents:empty + .divider {
  display: none;
}

/* Hairline between the Agents pill and the page controls */
.divider {
  width: 1px;
  height: 20px;
  background-color: var(--tuna-palette-divider);
  flex-shrink: 0;
}

/* Sentence case: "Main", "Share", "Perform" read as words. `button` outranks the Button primitive's uppercase. */
button.layoutSelector,
button.textButton,
button.performButton {
  text-transform: none;
  flex-shrink: 0;
}

/* The one filled button. Its focus ring needs a contrast gap against the primary fill. */
button.performButton:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
  box-shadow: 0 0 0 2px var(--tuna-palette-primary-contrastText);
}

/* Mobile Edit toggle: a text toggle in the bar, pressed while editing */
button.editToggle {
  text-transform: none;
  flex-shrink: 0;
  padding: 0 var(--tuna-spacing-1);
}

/* Compact Perform on small screens: a filled square icon button */
button.performCompact {
  min-width: 36px;
  padding: 6px;
}

/*
 * Small-screen touch targets: at least 44 × 44. The boxed Edit and Perform keep their look and extend an
 * invisible hit area instead (a few px into the 8px toolbar gap, so neighbours never overlap). The More
 * trigger has no visible box, so it simply grows.
 */
button.editToggle,
button.performCompact,
.compactBar .agents button {
  position: relative;
}

button.editToggle::after,
button.performCompact::after,
.compactBar .agents button::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: max(100%, 44px);
  height: max(100%, 44px);
  transform: translate(-50%, -50%);
}

button.moreCompact {
  min-width: 44px;
  min-height: 44px;
  padding: 0;
}
